// Plan pricing is billed in VND (VietQR bank transfers only settle in VND) and is independent of the
// per-user display-currency conversion used for expenses/budgets (see hooks/useCurrency.js)
// - so it gets its own formatter.
export function formatPlanPrice(amount, currency) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'VND' }).format(Number(amount) || 0);
}
